import type { ElementType, HTMLAttributes, ReactNode } from 'react'
import type { GravityKind } from '@/lib/universe/gravity'

import { createElement, useEffect, useRef } from 'react'
import { registerGravity } from '@/lib/universe/gravity'

interface GravityProps extends HTMLAttributes<HTMLElement> {
    as?: ElementType
    kind?: GravityKind
    fall?: boolean
    delay?: number
    children?: ReactNode
}

// Wraps anything that should come into focus out of the dark when it appears,
// and dim and stretch slightly towards the hole when it scrolls away on its side
const Gravity = ({
    as = 'div',
    kind = 'block',
    fall = true,
    delay = 0,
    children,
    ...rest
}: GravityProps): ReactNode => {
    const ref = useRef<HTMLElement>(null)

    useEffect(() => {
        const node = ref.current

        if (!node) return

        return registerGravity(node, { kind, fall, delay })
    }, [kind, fall, delay])

    return createElement(
        as,
        {
            ...rest,
            ref,
            'data-gravity': 'pending',
            'data-gravity-kind': kind
        },
        children
    )
}

export default Gravity
